import { useSelector } from 'react-redux';
import { BUSINESS_ACCOUNT_REGISTER_URL } from 'constants/routes';
import { getRefUrl } from 'libs/utils/url';
import * as selectors from 'state/auth/selectors';

const useSuccessUrl = defaultUrl => {
  const isBusinessAuth = useSelector(selectors.getIsBusinessAuth);
  if (isBusinessAuth) return BUSINESS_ACCOUNT_REGISTER_URL;
  return getRefUrl(defaultUrl);
};

export default useSuccessUrl;